import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            Programming has become a core part of who I am, and <b className="purple">I’m always eager to push my skills further</b>.
              <br />
              <br />
              I am fluent in classic programming languages such as
              <i>
                <b className="purple"> Java/Kotlin, C++, Python, Javascript and Typescript. </b>
              </i>
              <br />
              <br />
              I am interested in building new &nbsp;
              <i>
                <b className="purple">Web and mobile Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  AI.
                </b>
              </i>
              <br/>
              <br/>
              I am experienced in <span className="purple">Full Stack Development</span> from my current experience 
              at McMaster's Google Development Student Clubs Chapter.
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Sceptres"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/abdallahalqashqish/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
